/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  InviteUserMutationRequest,
  InviteUserMutationResponse,
  InviteUser400,
} from '../types/InviteUser'

function getInviteUserUrl() {
  const res = { method: 'POST', url: `/api/v1/invite-user/` as const }
  return res
}

/**
 * @description Invite a new user to the platform.
 * @summary Invite a new user
 * {@link /api/v1/invite-user/}
 */
export async function inviteUser(
  data: InviteUserMutationRequest,
  config: Partial<RequestConfig<InviteUserMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    InviteUserMutationResponse,
    ResponseErrorConfig<InviteUser400>,
    InviteUserMutationRequest
  >({
    method: 'POST',
    url: getInviteUserUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
